import React, { useMemo, useCallback } from 'react';
import List, { ListTypes } from 'devextreme-react/list';

import './UserMenuSection.scss';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRedirect, logout } from '../../../utils/authUtils';


export const UserMenuSection = ({ showAvatar, listRef }) => {

const user = JSON.parse(localStorage.getItem('account'));
const avatarUrl = "https://randomuser.me/api/portraits";
 const isAuthenticated = useIsAuthenticated();
 const { instance, accounts } = useMsal();
  const menuItems = useMemo(
    () => isAuthenticated ? [
      {
        text: 'Logout',
        icon: 'runner',
                onClick: () => logout(instance),
 
      }
    ] : [
      {
        text: 'Login',
        icon: 'runner',
       onClick: () => loginRedirect(instance),
 
      }
    ],
    [isAuthenticated]
  );

  const listElementAttr = {
    class: 'user-info-list'
  };

  const onItemClick = useCallback(({ itemData }) => itemData?.onClick(), []);

  return (
    <>
      <List ref={listRef} elementAttr={listElementAttr} onItemClick={onItemClick} items={menuItems} />
      
    </>
  );
};
